export interface Question {
  id: number;
  label: string;
  options: Option[];
}

export interface Option {
  label: string;
  value: TypeOption;
}

export enum TypeOption {
  A = 'A',
  B = 'B',
  C = 'C'
}
